import { createAppRequest } from '@/services/request';

const request = createAppRequest();

export interface OpenPlatformTokenResult {
  accessToken: string;
  expiresAt: number;
}

export function getOpenPlatformToken(): Promise<OpenPlatformTokenResult> {
  return request<OpenPlatformTokenResult>('/bff/open-platform/token', {
    method: 'GET',
  });
}
